import { transitionDuration } from "@utils/DOMUtilities";
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    slideInOut: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: "bg-secondary"
    }
  },
  data() {
    return {
      visible: false
    };
  },
  created() {
    this.visible = this.active;
  },
  watch: {
    active(val) {
      if (val) {
        this.visible = true;
      } else {
        let context = this;
        let width = context.$el.offsetWidth;
        let parentWidth = context.$el.parentElement.offsetWidth;
        let remainingDuration = transitionDuration(context.$vnode.elm) * (1 - width / parentWidth);
        if (!isNaN(remainingDuration)) {
          setTimeout(function () {
            context.visible = context.active;
          }, remainingDuration + 50);
        } else this.visible = val;
      }
    }
  }
};